import React, { FC, useState } from 'react'
import CheckIcon from 'svg/tick-redesign.svg'
import WrongIcon from 'svg/wrong.svg'
import PasswordInput from './PasswordInput'
import { RULES } from '../helpers'
import styles from '../Modals/Auth.module.scss'
import classNames from 'classnames'

const {
  COUNT_REGEX,
  DIGIT_REGEX,
  SPECIAL_CHARACTER_REGEX,
  LOWERCASE_REGEX,
  UPPERCASE_REGEX,
  PASSWORD_REGEX,
} = RULES

type Rules = {
  count: boolean
  digit: boolean
  lowercase: boolean
  password: boolean
  special: boolean
  uppercase: boolean
}

const validatePassword = (value: string): Rules => {
  return {
    count: !!value.match(COUNT_REGEX),
    digit: !!value.match(DIGIT_REGEX),
    lowercase: !!value.match(LOWERCASE_REGEX),
    password: !!value.match(PASSWORD_REGEX),
    special: !!value.match(SPECIAL_CHARACTER_REGEX),
    uppercase: !!value.match(UPPERCASE_REGEX),
  }
}

const DEFAULT_STATE = {
  password: '',
  rules: {
    count: false,
    digit: false,
    lowercase: false,
    password: false,
    special: false,
    uppercase: false,
  },
}

type State = {
  password: string
  rules: Rules
}

type PasswordCreationProps = {
  onChange: (...args: Array<any>) => any
  password: string
  passwordError: string
  styleOverride?: string
}

const PasswordCreation: FC<PasswordCreationProps> = (props) => {
  const { onChange, password, passwordError, styleOverride } = props
  const [state, handleState] = useState<State>({ ...DEFAULT_STATE })
  const { rules } = state
  const isValid = !!rules.password

  const updateInput = (event: React.SyntheticEvent<HTMLInputElement>): void => {
    const { value } = event.currentTarget
    handleState({ ...state, password: value })
    // inputDebounce(() => {
    const validatedRules = validatePassword(value)
    handleState({ ...state, rules: validatedRules })

    if (onChange) {
      onChange({
        isValid,
        value,
      })
    } // }, 500)
  }

  return (
    <div className={`${styles.passwordCreation} ${styleOverride}`}>
      <PasswordInput
        name='create-password'
        password={password}
        title='Create Password'
        onChange={updateInput}
        passwordError={passwordError}
        styleOverride={styleOverride}
      />
      <ul
        className={classNames(
          {
            [styles.passwordRulesEmpty]: !password,
          },
          styles.passwordRules
        )}
      >
        <li
          className={classNames(
            {
              [styles.passwordRuleInValid]: !rules.uppercase,
            },
            styles.passwordRule
          )}
        >
          {!rules.uppercase ? <WrongIcon /> : <CheckIcon />}
          <span>1 uppercase</span>
        </li>
        <li
          className={classNames(
            {
              [styles.passwordRuleInValid]: !rules.special,
            },
            styles.passwordRule
          )}
        >
          {!rules.special ? <WrongIcon /> : <CheckIcon />}
          <span>1 special character</span>
        </li>
        <li
          className={classNames(
            {
              [styles.passwordRuleInValid]: !rules.lowercase,
            },
            styles.passwordRule
          )}
        >
          {!rules.lowercase ? <WrongIcon /> : <CheckIcon />}
          <span>1 lowercase</span>
        </li>
        <li
          className={classNames(
            {
              [styles.passwordRuleInValid]: !rules.count,
            },
            styles.passwordRule
          )}
        >
          {!rules.count ? <WrongIcon /> : <CheckIcon />}
          <span>Min. of 8 characters</span>
        </li>
        <li
          className={classNames(
            {
              [styles.passwordRuleInValid]: !rules.digit,
            },
            styles.passwordRule
          )}
        >
          {!rules.digit ? <WrongIcon /> : <CheckIcon />}
          <span>1 number</span>
        </li>
      </ul>
    </div>
  )
}

export default PasswordCreation
